<template>
	<div class="indexHome no-trans" v-loading="loading">
		<div class="tops_box">
			<headers ref="headers"></headers>
		</div>
		<div class="cent_box">
			<router-view key="home_index"></router-view>
		</div>
		<div class="boms_box">
			<bottom ref="bottom"></bottom>
		</div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import headers from '../components/component/headers.vue'
	import bottom from '../components/component/bottom.vue'
	export default {
		components: {
			headers,
			bottom,
		},
		name: "index",
		data() {
			return {
				loading:false,
			}
		},
		computed: {
			...mapState(['vuex_user', 'vuex_unread_number'])
		},
		watch: {
			$route: {
				handler(newVal, oldVal) {
					 
					 

				},
				immediate: true,
				deep: true
			},
		},
		created() {
		 
		},
		methods: {
			 
		 
			 



		},

	}
</script>
<style scoped lang="less">
	.indexHome {
		width: 100%;
		height: 100vh;

		.tops_box {
	  
		}
		.cent_box{
			
		}

		.boms_box {
		 
		}

	}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .indexHome.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
}
</style>
